/* Prestige sections - slideshow, before/after, countdown, card swatches */
(function () {
  'use strict';
  if (window.__pxCoreLoaded) return;   /* every section links this file */
  window.__pxCoreLoaded = true;

  function slideshow(root) {
    if (root.dataset.pxInit) return;          /* guard against a second init */
    root.dataset.pxInit = '1';
    var slides = root.querySelectorAll('.px-slide');
    if (slides.length < 2) return;
    var dots = root.querySelector('.px-dots'), i = 0, timer;
    if (dots) dots.innerHTML = '';            /* start from a clean row */
    var auto = root.dataset.autoplay === 'true';
    var speed = (parseInt(root.dataset.speed, 10) || 6) * 1000;

    if (dots) slides.forEach(function (_, n) {
      var b = document.createElement('button');
      b.setAttribute('aria-label', 'Slide ' + (n + 1));
      b.addEventListener('click', function () { go(n); });
      dots.appendChild(b);
    });

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (el, k) { el.classList.toggle('on', k === i); });
      if (dots) dots.querySelectorAll('button').forEach(function (b, k) { b.setAttribute('aria-current', k === i); });
      restart();
    }
    function restart() {
      clearInterval(timer);
      if (auto && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(function () { go(i + 1); }, speed);
      }
    }
    var next = root.querySelector('.next'), prev = root.querySelector('.prev');
    if (next) next.addEventListener('click', function () { go(i + 1); });
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    go(0);
  }

  function beforeAfter(root) {
    var after = root.querySelector('.px-ba-after'),
        line = root.querySelector('.px-ba-line'),
        knob = root.querySelector('.px-ba-knob'),
        input = root.querySelector('.px-ba-range');
    if (!after || !input) return;
    function set(v) {
      after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
      if (line) line.style.left = v + '%';
      if (knob) knob.style.left = v + '%';
    }
    input.addEventListener('input', function (e) { set(e.target.value); });
    set(root.dataset.start || 50);
  }

  function countdown(root) {
    var end = new Date((root.dataset.end || '').replace(' ', 'T')).getTime();
    if (isNaN(end)) return;
    var d = root.querySelector('[data-d]'), h = root.querySelector('[data-h]'),
        m = root.querySelector('[data-m]'), s = root.querySelector('[data-s]');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) {
        root.innerHTML = '<p style="margin:0">' + (root.dataset.expired || '') + '</p>';
        clearInterval(t); return;
      }
      if (d) d.textContent = pad(Math.floor(left / 86400));
      if (h) h.textContent = pad(Math.floor(left / 3600) % 24);
      if (m) m.textContent = pad(Math.floor(left / 60) % 60);
      if (s) s.textContent = pad(left % 60);
    }
    var t = setInterval(tick, 1000); tick();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-px-slideshow]').forEach(slideshow);
    (scope || document).querySelectorAll('[data-px-ba]').forEach(beforeAfter);
    (scope || document).querySelectorAll('[data-px-clock]').forEach(countdown);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  /* re-run when a section is re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* ---------- colour swatches on product cards ----------
     Delegated, so it also covers cards added later by the theme editor. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-px-swatch]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.px-card');
    if (!card) return;

    var img = card.querySelector('.px-card__link img');
    if (img && sw.dataset.img) {
      img.setAttribute('srcset', '');
      img.src = sw.dataset.img;
    }
    if (sw.dataset.url) {
      card.querySelectorAll('a[href]').forEach(function (a) { a.href = sw.dataset.url; });
      var vid = card.querySelector('[name="id"]');
      if (vid) {
        var m = sw.dataset.url.match(/variant=(\d+)/);
        if (m) vid.value = m[1];
      }
    }
    card.querySelectorAll('[data-px-swatch]').forEach(function (x) {
      if (x === sw) { x.setAttribute('aria-current', 'true'); }
      else { x.removeAttribute('aria-current'); }
    });
  });

})();
